const MACRO_CODIGO = {
  CHEGADA_NA_PORTARIA: 1,
  ENTRADA_AUTORIZADA: 2,
  ENTRADA_NA_UNIDADE: 3,
  ENTRADA_NA_DOCA: 4,
  SAIDA_DA_DOCA: 5,
  SAIDA_DA_UNIDADE: 6,
  OUTROS: 7,
  PESAGEM_BALANCA_SAIDA: 8,
  ANALISE_DA_DOCUMENTACAO: 9,
  DOCUMENTACAO_OK: 10,
  DOCUMENTACAO_NAO_OK: 11,
  INICIO_CARREGAMENTO: 12,
  FIM_CARREGAMENTO: 13,
}

export default MACRO_CODIGO
